<script setup lang="ts">
import {PatientConversionWidget} from "@/laboratory/components/dashboard/dashboard";
import {computed, ref} from "vue";
import {Slider} from "@/core/components/ui/slider";
import {Widget} from "@/laboratory/components/dashboard/components/widget";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";
import {currencyze} from "@/core/filters/Currencyze";

const props = defineProps<{
    widget: PatientConversionWidget
}>();

const convertedPatients = ref([props.widget.data.patients.current]);

const computedReward = computed(() => {
    const maxRewardValue = props.widget.data.benefit.max;

    return maxRewardValue * (convertedPatients.value[0] / props.widget.data.patients.max);
});
</script>

<template>
  <Widget :widget="widget">
    <div class="flex gap-6">
      <div>
        <h3>{{ widget.data.label }}</h3>
        <ul>
          <li v-if="widget.data.sales.quantity">
            Boites vendues : {{ widget.data.sales.quantity }}
          </li>
        </ul>
      </div>
      <div class="flex-1">
        <div class="w-full px-8 flex items-center gap-2">
          <label>0</label>
          <Slider v-model:model-value="convertedPatients" :max="widget.data.patients.max" :step="1">
            <template #thumb>
              <div class="relative top-5 text-sm text-primary translate-x-1/4">
                {{ convertedPatients[0] }}
              </div>
            </template>
          </Slider>
          <label>{{ widget.data.patients.max }}</label>
        </div>
      </div>
      <div>
        <h2>
          {{ widget.data.benefit.label }}
          <InformationTooltip v-if="widget.data.benefit.description" class="w-4 h-4">
            {{ widget.data.benefit.description }}
          </InformationTooltip>
        </h2>
        <h1>{{ currencyze(computedReward) }} / <span class="text-base">{{ currencyze(widget.data.benefit.max) }}</span></h1>
      </div>
    </div>
  </Widget>
</template>

<style scoped>

</style>
